module.exports = __webpack_public_path__ + "static/woman-pineapple-square.0120910d.jpg";